module.exports = __webpack_public_path__ + "static/img/santa.98137d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/santa.png
// module id = nP/0
// module chunks = 1